import React from 'react'

export default ({ className }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`bluebutton__icon${className ? ` ${className}` : ''}`}
  >
    <g id="icon/content/how_to_reg_24px">
      <path
        id="icon/content/how_to_reg_24px_2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.875 5.8125C10.875 7.47 9.5325 8.8125 7.875 8.8125C6.2175 8.8125 4.875 7.47 4.875 5.8125C4.875 4.155 6.2175 2.8125 7.875 2.8125C9.5325 2.8125 10.875 4.155 10.875 5.8125ZM9.375 5.8125C9.375 4.9875 8.7 4.3125 7.875 4.3125C7.05 4.3125 6.375 4.9875 6.375 5.8125C6.375 6.6375 7.05 7.3125 7.875 7.3125C8.7 7.3125 9.375 6.6375 9.375 5.8125ZM3.375 13.3125C3.525 12.84 5.3025 12.0525 7.095 11.8575L8.625 10.3575C8.3325 10.3275 8.115 10.3125 7.875 10.3125C5.8725 10.3125 1.875 11.3175 1.875 13.3125V14.8125H8.625L7.125 13.3125H3.375ZM11.2275 13.065L15.075 9.1875L16.125 10.245L11.2275 15.1875L8.625 12.5625L9.675 11.505L11.2275 13.065Z"
        fill="#447ADC"
      />
    </g>
  </svg>
)
